export default "__VITE_ASSET__CTK__WLJ__"